/** Backend API host (paths in hooks are prefixed with /api/...). */
export const API_BASE_URL = "https://api.xn--ibnn-hra.no";
